import React from "react";
import { ArrowRight, ArrowDown } from "lucide-react";

/**
 * Line diagram of a workflow: trigger, steps, result.
 * Horizontal on desktop, vertical on mobile.
 */
export const FlowDiagram = ({ steps, testId = "flow-diagram", onDark = false, compact = false, vertical = false }) => {
  const box = onDark
    ? "border-[#F4E9D8]/30 text-[#F4E9D8] bg-[#F4E9D8]/[0.06]"
    : "border-[#1F1F1C]/20 text-[#1F1F1C] bg-[#F4E9D8]";
  const arrow = onDark ? "text-[#C8703A]" : "text-[#C8703A]";
  const label = onDark ? "text-[#F4E9D8]/55" : "text-[#4A463F]";

  return (
    <div
      className={vertical ? "flex flex-col gap-2" : "flex flex-col sm:flex-row sm:flex-nowrap sm:items-stretch gap-2"}
      data-testid={testId}
    >
      {steps.map((s, i) => {
        const text = typeof s === "string" ? s : s.label;
        const kind = typeof s === "string" ? null : s.kind;
        return (
          <React.Fragment key={text}>
            <div
              className={`rounded-2xl border ${box} ${compact ? "px-4 py-3" : "px-4 py-4 sm:px-5"} flex-1 sm:min-w-0`}
              data-testid={`${testId}-step-${i + 1}`}
            >
              {kind && (
                <span className={`block text-[10px] uppercase tracking-[0.18em] font-semibold mb-1.5 ${label}`}>
                  {kind}
                </span>
              )}
              <span className={`font-semibold ${compact ? "text-sm" : "text-sm"} leading-snug`}>
                {text}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div className="flex items-center justify-center sm:py-0" aria-hidden="true">
                <ArrowRight className={`${vertical ? "hidden" : "hidden sm:block"} w-4 h-4 ${arrow}`} strokeWidth={2.5} />
                <ArrowDown className={`${vertical ? "block" : "sm:hidden"} w-4 h-4 ${arrow}`} strokeWidth={2.5} />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default FlowDiagram;
